import { db } from '../lib/database'
import { dataMigrationUtils } from '../utils/dataMigration'

export const dataInitService = {
  initializeDatabase() {
    return db.open()
      .catch('UpgradeError', () => db.delete().then(() => db.open()))
      .then(() => db.settings.get('migrated_v12'))
      .then((migrationSetting) => {
        if (!migrationSetting?.value) {
          return dataMigrationUtils.runMigration().then((result) => {
            if (result.success) {
              return db.settings.put({ key: 'migrated_v12', value: true })
            }
          })
        }
      })
      .catch(() => {})
  },
}